export default __webpack_public_path__ + "static/media/volkswagen.2e85eb31.svg";